import React from 'react'
import AccordionSecondary from './../../../components/accordion/accordion-secondary.component'
import PaymentInfoContent from './payment-info-content.component'
import RedeemButton from './redeem-button.component'
import {
	StyledFlexContainer,
	StyledContainer,
	StyledPaymentMethodContainer,
	StyledActionsContainer,
	StyledIconFontAwesome
} from './styled-components'
import { UserService } from './../../../services/user.service'
import ProductQuantitySelector from './product-quantity-selector.component'
import { RoleConstants } from './../../../constants/role.constants'

import PixLogo from '../../../../assets/images/logo-pix.png'

class PaymentInfo extends React.Component {
	constructor(props) {
		super(props)
		this.getAccordionItems = getAccordionItems.bind(this)

		this.state = {
			role: null,
			selectedCondition: 0
		}
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.paymentConditions.length !=
			this.props.paymentConditions.length
		) {
			const selectedCondition = nextProps.paymentConditions
				.map((item, index) => ((item.index = index), item))
				// .find(
				// 	({ order, forSubscribers }) => !forSubscribers && order === 1
				// ).index
				.find(({ order, forSubscribers }) => !forSubscribers).index

			this.setState({ selectedCondition })
		}
	}

	async componentDidMount() {
		const { user } = this.props
		const notAuthenticated = user === null

		if (notAuthenticated) return

		const role = await UserService.getMostImportantRole(user.roles)
		this.setState({ role })
	}

	render() {
		const {
			user,
			client,
			className,
			productId,
			paymentConditions
		} = this.props
		const { role, selectedCondition } = this.state
		const paymentCondition = paymentConditions[selectedCondition]
		let notAuthenticated = user === null

		return (
			<StyledContainer className={className}>
				<AccordionSecondary
					arrow={false}
					multiple={false}
					noClickable
					noAnimated
					items={this.getAccordionItems()}
				/>
				{!(RoleConstants.Client !== role && !notAuthenticated) ? (
					<div className="actions-container">
						<div className="actions-subcontainer">
							<ProductQuantitySelector
								productQuantity={this.props.productQuantity}
								handleProductDecrease={this.props.handleProductDecrease}
								handleProductIncrease={this.props.handleProductIncrease}
								qttMin={this.props.qttMin}
								qttMax={this.props.qttMax}
							/>
							<div className="btn-container">
								<RedeemButton
									role={role}
									user={user}
									client={client}
									productId={productId}
									paymentCondition={paymentCondition}
								/>
								<div className="payment-methods">
									<div>
										<img src={PixLogo} alt="Pix" />
									</div>
									<div>
										<StyledIconFontAwesome
											name="credit-card"
											title="Cartão de crédito"
										/>
									</div>
								</div>
							</div>
						</div>
					</div>
				) : null}
			</StyledContainer>
		)
	}
}

function getAccordionItems() {
	const { productId, paymentConditions, productName, user } = this.props
	const { selectedCondition } = this.state

	return [
		{
			title: productName,
			content: (
				<PaymentInfoContent
					user={user}
					productId={productId}
					paymentConditions={paymentConditions}
					selectedCondition={selectedCondition}
					onPaymentSelected={selectedCondition =>
						this.setState({ selectedCondition })
					}
				/>
			)
		}
	]
}

export default PaymentInfo
